
<template>
  <div>
    <div class="search_block">
      <!--新增 搜索区域-->
      <Form :label-width="100" inline>
        <FormItem label="序列编号">
          <Input class="w-250" v-model="table.search.seriesNumber"></Input>
        </FormItem>
        <FormItem label="imageID">
          <Input class="w-250" v-model="table.search.imageID"></Input>
        </FormItem>
        <FormItem label="影像序号">
          <Input class="w-250" v-model="table.search.imageNumber"></Input>
        </FormItem>
        <FormItem label="SERIESUID">
          <Input class="w-250" v-model="table.search.seriesInstanceUID"></Input>
        </FormItem>
        <FormItem label="开始时间">
          <Time-picker
            type="time"
            placeholder="选择时间"
            format="HH:mm:ss"
            v-model="table.search.begintime"
            @on-change="change_begintime"
            style="width: 250px"
          ></Time-picker>
          
        </FormItem>
        <FormItem label="结束时间">
           <Time-picker
            type="time"
            placeholder="选择时间"
            format="HH:mm:ss"
            v-model="table.search.endtime"
            @on-change="change_endtime"
            style="width: 250px"
          ></Time-picker>
        </FormItem>
      </Form>
      <!--操作区域-->
      <!-- mb-4 ml-5 -->
      <div class="possion_fu">
        <Button class="mr-3 possion" type="success" @click="search"
          >查询</Button
        >
      </div>
    </div>
    <!--列表区域-->
    <DataTable
      ref="imageinfolistTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      @selectionChange="selectionChange"
    ></DataTable>
    <div class="ml-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
    <!--详情-->
    <Modal
      width="700"
      v-model="detailModal"
      title="详情"
      :footer-hide="true"
      :closable="false"
    >
      <imageinfodetail
        v-if="detailModal"
        @close="detailModal = false"
        :currentData="currentData"
      ></imageinfodetail>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import imageinfodetail from "../study/imageinfodetail.vue";

export default {
  components: { DataTable, imageinfodetail },
  props: ["StudyId", "SeriesId"],
  data: function () {
    return {
      currentData: {},
      detailModal: false,

      table: {
        columns: [
          //   {
          //     type: "selection",
          //     width: 60,
          //     align: "center",
          //   },
          {
            title: "序号",
            fixed: "left",
            type: "index",
            width: "60",
            align:'center'
          },
          {
            tooltip: true,
            width: 100,
            title: "影像日期",
            key: "imageDate",
            align:'center'
          },
          {
            tooltip: true,
            width: "100",
            title: "目录",
            key: "imageDicPath",
            align:'center'
          },
          
          {
            tooltip: true,
            width: "100",
            title: "文件名称",
            key: "imageFileName",
            align:'center'
          },
          { tooltip: true, width: "100", title: "ImageID", key: "imageID",align:'center' },
          {
            tooltip: true,
            width: "100",
            title: "影像序号",
            key: "imageNumber",
            align:'center'
          },
          {
            tooltip: true,
            width: "130",
            title: "影像路径",
            align:'center',
            render:(h, params) => {
              return h('Tooltip',
                {
                  class:{
                    tableTooltip:true
                  },
                  scopedSlots:{
                    content:()=>{
                      return h('div',{
                        style:{
                          whiteSpace:'normal'
                        }
                      },params.row.imageDicPath+'/'+params.row.imageRelatePath)
                    }
                  }
                },params.row.imageDicPath+'/'+params.row.imageRelatePath
              )
            }
          },
          {
            tooltip: true,
            width: "120",
            title: "相对路径",
            key: "imageRelatePath",
            align:'center'
          },
          {
            tooltip: true,
            width: "100",
            title: "影像时间",
            key: "imageTime",
            align:'center'
            //  render: (h, params) => {
            //    return h("div", [
            //      h(
            //       "Button",
            //       {
            //         props: {
            //           type: "primary",
            //           size: "small",
            //         },
            //         style: {
            //           marginRight: "5px",
            //         },
            //         on: {
            //           click: () => {
            //             this.toDetail(params.row);
            //           },
            //         },
            //       },
            //       params.row.imageTime
            //     ),
            //    ])
            //  }
          },
          {
            tooltip: true,
            width: "120",
            title: "关键影像标志",
            key: "keyImage",
            align:'center'
          },
          // {
          //   tooltip: true,
          //   width: "100",
          //   title: "LastUpdateDate",
          //   key: "lastUpdateDate",
          // },
          {
            tooltip: true,
            width: "100",
            title: "机构编码",
            key: "organCode",
            align:'center'
          },
          {
            tooltip: true,
            width: "120",
            title: "序列ID",
            key: "seriesID",
            align:'center'
          },
          {
            tooltip: true,
            width: "120",
            title: "SERIESUID",
            key: "seriesInstanceUID",
            align:'center'
          },
          {
            tooltip: true,
            width: "100",
            title: "序列编号",
            key: "seriesNumber",
            align:'center'
          },
          {
            tooltip: true,
            width: "100",
            title: "层厚",
            key: "slicethickness",
            align:'center'
          },
          {
            tooltip: true,
            width: "110",
            title: "SOPClassUID",
            key: "sOPClassUID",
            align:'center'
          },
          {
            tooltip: true,
            width: "100",
            title: "SOPUID",
            key: "sOPInstanceUID",
            align:'center'
          },
          // {
          //   tooltip: true,
          //   width: "100",
          //   title: "STUDYID",
          //   key: "studyID",
          // },
          {
            tooltip: true,
            width: "100",
            title: "STUDYUID",
            key: "studyInstanceUID",
            align:'center'
          },
          { tooltip: true, width: "100", title: "窗位", key: "winCenter" },
          { tooltip: true, width: "100", title: "窗宽", key: "winWide" },
          {
            title: "操作",
            align:'center',
            fixed: "right",
            width: "120px",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "详情"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      color:'#FA6266',
                    },
                    on: {
                      click: () => {
                        this.toDelete(params.row);
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
          },
        ],
        apiUrl:
          "StudyInfo/GetImageInfoList?StudyInfoId=" +
          this.StudyId +
          "&SeriesId=" +
          (this.SeriesId ? this.SeriesId : ""),
        search: {
          seriesNumber: "", //序列编号
          imageID: "", //序列编号
          imageNumber: "", //影像序号
          seriesInstanceUID: "", //SERIESUID

          begintime: "",
          endtime: "",
        },
      },
    };
  },

  mounted: function () {
    this.search()
  },

  methods: {
    search: function () {
      this.$refs.imageinfolistTable.initload();
    },
    change_begintime(value){
      // value.split("-")
      // console.log("666",value.split("-").join(''));
      this.table.search.begintime = value.split(":").join('')
    },
    change_endtime(value){
      // value.split("-")
      // console.log("666",value.split("-").join(''));
      this.table.search.endtime = value.split(":").join('')
    },
    toDetail: function (data) {
      this.detailModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
    },
    toDelete: function (data) {
      this.$Modal.confirm({
        title: "确认要删除吗？",
        mask: false,
        onOk: () => {
          this.$api
            .get("StudyInfo/DeleteImage?imageID=" + data.imageID)
            .then((rsp) => {
              if (rsp != false) {
                this.$Message.success("删除成功");
                this.search();
              }
            });
        },
      });
    },

    returnBack: function () {
      this.$emit("close");
    },
    //单个删除
    deleteSingle: function (id) {
      this.$Modal.confirm({
        title: "操作不可逆,是否继续？",
        mask: false,
        onOk: () => {
          this.$api.post(`/e_imageinfo/delete?id=${id}`).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("删除成功");
              this.search();
            }
          });
        },
      });
    },
    //多选回调
    selectionChange(data) {
      this.selectionData = data;
    },
  },
};
</script>
<style scoped>
.aa {
  background-color: aqua;
  cursor: pointer;
}
.search_block {
  display: flex;
  align-items: flex-end;
}

.possion {
  margin-bottom: 20px;
}
</style>